<template>
  <div>
    <p v-if="label" class="top-label">
      {{ label }}
      <span v-if="required" class="reqstar">*</span>
    </p>
    <p v-if="helper_text" class="helper-text">{{ helper_text }}</p>
    <label v-for="(option, index) in compOptions" :key="index">
      <input
        type="radio"
        :value="option.value"
        :name="`radio_${_uid}`"
        :checked="option.value == checked"
        @change="handleInputChange"
        :disabled="disabled"
      />
      <span>{{ option.label }}</span>
    </label>
    <label v-if="other">
      <input
        type="radio"
        value="other"
        :name="`radio_${_uid}`"
        @change="handleInputChange"
        :disabled="disabled"
      />
      <span>{{ otherLabel }}</span>
    </label>
    <p v-if="isOtherSelected" class="other">
      <label :for="`select_other_${_uid}`">
        {{ otherLabel }}
        <br />
        <input
          type="text"
          :id="`select_other_${_uid}`"
          @input="handleValueChange"
        />
      </label>
    </p>
    <p v-if="error" class="validation-error">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: "FormRadio",
  props: {
    label: {
      type: String,
      default: "Select",
    },
    helper_text: {
      type: String,
      default: "Select",
    },
    options: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    other: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: [String, Boolean],
      default: false,
    },
    checked: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isOtherSelected: false,
      otherLabel: "Other, please specify",
      testVal: null,
    };
  },
  computed: {
    compOptions() {
      const optionArray = this.options.split("\n");
      const returnArr = optionArray.map((option) => {
        const parts = option.split(":");
        return { value: parts[0], label: parts[1] };
      });
      return returnArr;
    },
  },
  methods: {
    handleInputChange(e) {
      if (e.target.value === "other") {
        this.isOtherSelected = true;
      } else {
        this.isOtherSelected = false;
      }
      this.testVal = e.target.value;
      this.$emit("input", e.target.value);
    },
    handleValueChange(e) {
      this.$emit("input", e.target.value);
    },
  },
};
</script>
<style lang="scss" scoped>
label {
  display: flex;
  align-items: flex-start;

  input {
    margin-right: 10px;
  }
  + label {
    margin: 10px 0;
  }
}
.top-label {
  font-size: 1.25rem;
  line-height: 120%;
  margin: 0.5em 0;
  color: $colour-black-tint;
}

.reqstar {
  color: red;
}

.other {
  label {
    font-size: 1.25rem;
    line-height: 1.2;
    padding-bottom: 0.5rem;
    display: inline-block;
    width: 100%;
  }
  input[type="text"] {
    padding: 10px;
    width: 100%;
    @media (min-width: 768px) {
      max-width: 50vw;
    }
  }
}

.helper-text {
  font-size: 14px;
  margin: 0;
  margin-bottom: 1em;
}
</style>
